import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(private router: Router, private authenticationService: AuthenticationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!AuthenticationService.isLogined()) {
      this.router.navigateByUrl('login');
      return false;
    }
    // this.router.navigateByUrl('positions');
    return true;
  }

  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean> {
  //   return this.authenticationService.isAuthenticated()
  //     .pipe(
  //       tap(loggedIn => {
  //         if (!loggedIn) {
  //           this.router.navigate(['/login']);
  //         }
  //       })
  //     );
  // }

}
